import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useBoundStore } from 'useStore';
import ShortLargeValues from './ShortLargeValues';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';

const ColumnNumberField = memo(({ value, month, id, field }) => {
	const editedRows = useBoundStore((state) => state.forecastEditedRows);

	const fieldId = field.split('-')[1];

	const editedValue = editedRows[id]?.[month]?.[fieldId] ?? value;

	return <FieldNumber value={editedValue} fieldId={fieldId} />;
});

export default ColumnNumberField;

const FieldNumber = memo(({ value, fieldId }) => {
	const prefix = ['gmv_usd', 'gmv_local', 'profit', 'pvp'].includes(fieldId)
		? '$'
		: '';
	const suffix = ['mg'].includes(fieldId) ? '%' : '';

	return (
		<Stack
			spacing="0px"
			sx={{
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
			}}
		>
			<Typography>
				{prefix}
				{['gmv_usd', 'gmv_local'].includes(fieldId) ? (
					<ShortLargeValues value={value} field={fieldId} />
				) : (
					formatearNumeroConComas(Math.floor(value * 10) / 10)
				)}

				{suffix}
			</Typography>
		</Stack>
	);
});
